var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H8C3.58172 0 0 3.58172 0 8V52C0 56.4183 3.58172 60 8 60H52C56.4183 60 60 56.4183 60 52V8C60 3.58172 56.4183 0 52 0Z",
    fill: "#FCEBE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7504 30.75L16.5004 26.75C18.5004 25 19.5004 22.5 20.0004 20C20.0004 19.5 20.7504 19 21.2504 19.5L25.2504 23.5C25.5004 23.75 25.7504 23.75 26.0004 23.75C26.2504 23.75 26.5004 23.5 26.7504 23.25L27.7504 20.75C29.2504 17.5 30.0004 13.75 29.7504 9.5L30.5004 10.25C30.7504 10.5 31.2504 11 31.5004 11.25C36.7504 17.25 38.2504 25.5 35.2504 33.25C35.2504 35 36.0004 36.75 37.5004 37.5C39.0004 38.25 41.0004 37.75 42.0004 36.25C43.7504 33.5 45.2504 30.5 46.0004 27.25L47.0004 23.5L48.2504 27.25C50.5004 34.5 49.0004 42.25 44.2504 48.25C41.7504 51.5 37.5004 53.25 33.5004 53.25H25.2504C18.7504 53.25 12.7504 48.5 11.5004 41.5C10.5004 37.75 11.7504 34 13.7504 30.75Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 6.75098C34.75 6.75098 41.75 10.251 41 18.751",
    stroke: "#F78670",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAag);
export default __webpack_public_path__ + "static/media/Aag.da9396cf024157f80598d2893b5d502c.svg";
export { ForwardRef as ReactComponent };